module.exports = __webpack_public_path__ + "static/quran.11dac612.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/examples/thumbnails/quran.jpg
// module id = 853
// module chunks = 73261030922168